import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

interface ClearSearchButtonProps {
  onClick: () => void;
}

const ClearSearchButton = ({ onClick }: ClearSearchButtonProps) => {
  return (
    <StyledIconButton onClick={onClick} color="default">
      <PolarisIcon icon="close_filled" height={20} />
    </StyledIconButton>
  );
};

export default ClearSearchButton;

const StyledIconButton = styled(IconButton)`
  padding: 0;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }
`;
